
import React from 'react';

interface StatCardProps {
  value: string;
  label: string;
  icon: React.ReactNode;
}

const StatCard = ({ value, label, icon }: StatCardProps) => {
  return (
    <div className="tech-card p-6 text-center bg-white relative overflow-hidden group hover:shadow-lg transition-all duration-300">
      {/* Background gradient that shows on hover */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
      
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center">
          {icon}
        </div>
      </div>
      <h3 className="text-3xl font-bold mb-2 gradient-text">{value}</h3>
      <p className="text-muted-foreground">{label}</p>
    </div>
  );
};

export default StatCard;
